export const tinyAPIKey = "tilkj1d72ikzdlrhebsuwuzfi7wm1g5bdaxv50tfh1dkhx8l";

// `name` and `path` are used internally for tab selection and routing - DO NOT change them.
// `label` is the visible tab text only.
export const EventTabs = [
    { id: 1, name: 'General',      label: 'Event Details',        path: 'general',      desc: 'General tab for managing event properties' },
    { id: 2, name: 'Registration', label: 'Registration Settings', path: 'registration', desc: 'Manage registrations(products)' },
    { id: 3, name: 'Status',       label: 'Event Messaging',       path: 'status',       desc: 'Manage status of event' },
];

export const RolePermissions = [
    { id: 1, name: 'Administrator', Access:'users,events,finances,reporting,roles,settings,certifications,checkin'},
    { id: 2, name: 'Event Administrator', Access:'users,events,checkin'},
    { id: 3, name: 'Checkin Staff', Access:'events,checkin'},  
];

export const AdminRoles = {
    CMSCommunityAdministrator: "CMS Community Administrator",
    CMSDeskAdministrator: "CMS Desk Administrator",
    BOMAdministrator: "BOM Administrator",
    BOMCheckInStaff: "BOM Check-In Staff",
    BOMDRCoordinator: "BOM DR Coordinator",
    BOMDRTrainingAdministrator: "BOM DR Training Administrator",
    BOMEvenAdministrator: "BOM Event Administrator",
    BOMEventCoordinator: "BOM Event Coordinator",
    BOMSuperAdministrator: "BOM Super Administrator",
}